<template>
<div class="app-wrap">
  <!-- <Header></Header> -->
  <router-view/>
</div>
</template>

<script setup>

</script>

<style>
:root {
  font-size: 12px;
  /* background-color: #f2f2f2; */
}

#app {
  min-width: 1700px;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
  z-index: 1000;
  background-color: #fff;
}

body,
div,
p,
ul,
li,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6 {
  display: block;
  list-style: none;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  /* font-size: .24rem; */
}

img {
  display: block;
}

input {
  display: block;
  padding: 0;
  margin: 0;
  outline:none;
  box-sizing: border-box;
}

a img {
  border: 0;
}

a {
  outline: none;
  text-decoration: none;
  color: #2e2e2e;
}

a:link {
  text-decoration: none;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.el-select-dropdown__wrap {
  max-height: 1000px !important;
}
</style>
